let header = {
  'token': sessionStorage.getItem('token') || localStorage.getItem('token'),
  'actor': sessionStorage.getItem('actor') || localStorage.getItem('actor'),
  'branch': sessionStorage.getItem('branch') || localStorage.getItem('branch'),
  'organ':  sessionStorage.getItem('organ') || localStorage.getItem('organ'),
  'channel': sessionStorage.getItem('channel') || localStorage.getItem('channel'),
}
export default API => ({
  /**
   * 获取明细表数据
   */
  getChartTable(data){ 
    return API({
      url: `/bi/v1/dashboard/detailList`,
      method: 'post',
      data: data,
      headers: header
    });
  },
  /**
   * 获取柱形图数据
   */
  getChartBarData(data){ 
    return API({
      url: `/bi/v1/dashboard/barChart`,
      method: 'post',
      data: data,
      headers: header
    });
  },
  /**
   * 获取指标版数据
   * 
   */
  getChartBoard(data) {
    return API({
      url: `/bi/v1/dashboard/indicatorBoard`,
      method: 'post',
      data: data,
      headers: header
    });
  },
  /**
   * 获取大饼图数据
   */
   getChartPieData(data){ 
    return API({
      url: `bi/v1/dashboard/pieChart`,
      method: 'post',
      data: data,
      headers: header
    });
  },
   /**
   * 获取文本日期
   */
  getTextDate(id) {
    return API({ 
      url: `bi/v1/dashboard/text?dataSetId=${id}`, 
      method: 'GET',
      headers: {
        'content-type': 'application/json'
      }
    });
  }
})
